import React from 'react'
import Header from './header/Header';
import Footer from './footter/Footer';
import Banner from './inicio/Banner';
import Servicios from './inicio/Servicios';
import MapaOrganizacion from './inicio/MapaOrganizacion';
import Contact from './inicio/Contact';
const Inicio = () => {
    return (
        <div>
            <Header />
            <Banner/>
            <Servicios/>
            <MapaOrganizacion/>
            <Contact/>
            <Footer/>
        </div>
    )
}


export default Inicio
